<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Dedication</h1>
</div>
</div>
<div class="start">
<div class="block">
<p style="text-align: justify;">
			This book is dedicated to my family, without whose support its inception and creation would not have been possible: to my husband, Larry, for his encouraging me to write it and his determination to see it through to the end; to my daughter, Tracy, for listening to my moans and groans when I couldn’t come up with just the right word or phrase; to my son, Corey, for not complaining about skipped or late meals; and to my sister, Deborah, for having the patience to read and critique my every word. My heartfelt thinks to each—I could not have done it otherwise.</p>
</div>
</div>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap139510.vue?2d3cf1f2